import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useIdTaskUpdater} from '@components/id-tasks/use-id-task-updater'
import {useUrlUpdater} from '@containers/hooks'
import {
  ChatUtils,
  idTaskRegexp,
  isChat,
  panelRegexp
} from '@extensions/chat-utils'
import {PageService} from '../../../extensions/page-service'
import {RightPanelBase} from './right-panel-base'

export const RightPanel = observer(() => {
  const url = PageService.getUrl()
  useUrlUpdater()

  useIdTaskUpdater()

  const chatId = isChat(url)
    ? (ChatUtils.getChatFromCurrentUrl() || {id: undefined}).id
    : undefined
  const activePanel = getActivePanel(url)

  return <RightPanelBase activePanel={activePanel} chatId={chatId} />
})

const getActivePanel = (
  url: string
): 'personal_chats' | 'task_chats' | 'news' => {
  if (idTaskRegexp.test(url)) {
    return 'task_chats'
  }

  const panelMatch = url.match(panelRegexp)
  if (!panelMatch) {
    return 'task_chats'
  }

  const [, isTaskChats, isPersonalChats, isNews] = panelMatch

  if (isTaskChats) {
    return 'task_chats'
  }

  if (isPersonalChats) {
    return 'personal_chats'
  }

  if (isNews) {
    return 'news'
  }

  return 'personal_chats'
}
